import { render, staticRenderFns } from "./NewFeatureModal.vue?vue&type=template&id=46808cbc&scoped=true&"
import script from "./NewFeatureModal.vue?vue&type=script&lang=js&"
export * from "./NewFeatureModal.vue?vue&type=script&lang=js&"
import style0 from "./NewFeatureModal.vue?vue&type=style&index=0&id=46808cbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46808cbc",
  null
  
)

export default component.exports